<div class="SLV2-memoycrdbnner-box">
    <h3 class="SLV2-memoycrdbnner-title">
        <img class="icon-img" src="selflearnv2-ui/assets/img/self-learn-v2/memory-card-icon.svg" />
       <!-- <span>Card of the day!</span> -->
        <span>{{isMemoryCard ? 'Memory Cards' : 'Card of the day!'}}</span>
    </h3>

    <p class="SLV2-memoycrdbnner-text">Specially curated flashcards with built-in algorithms to increase your memory capacity</p>

    <button class="SLV2-prctcs-solid-button" (click)="navigateToCardofTheDay()">Go to memory cards</button>
</div>
